import BlockListHeader from "~/layout/block-list/ListHeader";

export { StyledBlockListHeader } from "~/layout/block-list/ListHeader";

export default BlockListHeader;
